import type { OrganisationAllowance } from "@keydials/api-client";
import { builderCopy, fill } from "./copy";

/** What the limit sheet says. */
export interface LimitSheetView {
  title: string;
  message: string;
}

/**
 * The sheet a full plan opens instead of the builder (KEY-560): the plan's name, and the server's own sentence word for word, so
 * the builder says exactly what pressing Create would have been refused with. Null while there's room to build.
 */
export function designLimitSheet(allowance: OrganisationAllowance | null): LimitSheetView | null {
  if (!allowance || allowance.canCreateDefinition) return null;
  const plan = allowance.plan ? `${allowance.plan.family} ${allowance.plan.tier}` : builderCopy.limits.yourPlan;
  return {
    title: plan,
    message: allowance.cannotCreateReason ?? fill(builderCopy.limits.designsFallback, { plan }),
  };
}
